// extracted by mini-css-extract-plugin
module.exports = {"reversal-container":"styles_reversal-container__3nJSn"};